<template>
  <div>
    <input type="checkbox" name="agree" id="tc-checkbox" @click="checkTC()">
    I accept the
    <span class="toc" @click="openPopup()">Terms of Service</span>
  </div>
</template>

<script>
export default {
  methods: {
    openPopup() {
      this.$emit("openPopup", true);
    },
    checkTC(e) {
      const TCaccepted = document.getElementById("tc-checkbox").checked;
      this.$emit("checkTC", TCaccepted);
    }
  }
};
</script>

<style>
</style>
